// extracted by mini-css-extract-plugin
module.exports = {"falseForm":"_1Y-2xg","falseButton":"_2tbpie"};